'use client';

import {
  aiGeneratedImageCaptionAtom,
  codeThemeAtom,
  enableKatexAtom,
  enablePostNewsletterAtom,
  extractCoverImageAtom,
  postCssAtom,
  postJsAtom,
  postNewsletterDescriptionAtom,
  postNewsletterTitleAtom,
  publishAtAtom,
  publishedDateTypeAtom,
  shareListAtom,
  showBreadcrumbAtom,
  showCodeLineNumberAtom,
  showCommentAtom,
  showExcerptAtom,
  showLikeAtom,
  showMoreFromAtom,
  showPublishDateAtom,
  showReadTimeAtom,
  showTocAtom,
} from 'app/blog/[domain]/_components/design-state';
import type { SelectPostDesignSchema } from 'database';
import { useStore } from 'jotai';
import { useHydrateAtoms } from 'jotai/utils';

export type HydratePostAtoms = Partial<SelectPostDesignSchema> & {
  publishAt?: Date | null;
};

export function HydratePostAtoms(props: HydratePostAtoms) {
  const store = useStore();
  useHydrateAtoms(
    // @ts-expect-error - fix types
    [
      typeof props.showBreadcrumb === 'boolean' && [
        showBreadcrumbAtom,
        props.showBreadcrumb,
      ],
      typeof props.showReadTime === 'boolean' && [
        showReadTimeAtom,
        props.showReadTime,
      ],
      typeof props.showExcerpt === 'boolean' && [
        showExcerptAtom,
        props.showExcerpt,
      ],
      typeof props.extractCoverImage === 'boolean' && [
        extractCoverImageAtom,
        props.extractCoverImage,
      ],
      Array.isArray(props.shareList) && [shareListAtom, props.shareList],
      typeof props.showPublishDate === 'boolean' && [
        showPublishDateAtom,
        props.showPublishDate,
      ],
      typeof props.publishedDateType === 'string' && [
        publishedDateTypeAtom,
        props.publishedDateType,
      ],
      typeof props.aiGeneratedImageCaption === 'boolean' && [
        aiGeneratedImageCaptionAtom,
        props.aiGeneratedImageCaption,
      ],
      typeof props.showCodeLineNumber === 'boolean' && [
        showCodeLineNumberAtom,
        props.showCodeLineNumber,
      ],
      typeof props.enableKatex === 'boolean' && [
        enableKatexAtom,
        props.enableKatex,
      ],
      typeof props.codeTheme === 'string' && [codeThemeAtom, props.codeTheme],
      typeof props.showToc === 'boolean' && [showTocAtom, props.showToc],
      typeof props.showComment === 'boolean' && [
        showCommentAtom,
        props.showComment,
      ],
      typeof props.showLike === 'boolean' && [showLikeAtom, props.showLike],
      typeof props.showMoreFrom === 'boolean' && [
        showMoreFromAtom,
        props.showMoreFrom,
      ],
      typeof props.enablePostNewsletter === 'boolean' && [
        enablePostNewsletterAtom,
        props.enablePostNewsletter,
      ],
      typeof props.postNewsletterTitle === 'string' && [
        postNewsletterTitleAtom,
        props.postNewsletterTitle,
      ],
      typeof props.postNewsletterDescription === 'string' && [
        postNewsletterDescriptionAtom,
        props.postNewsletterDescription,
      ],
      typeof props.customCss === 'string' && [postCssAtom, props.customCss],
      typeof props.customJs === 'string' && [postJsAtom, props.customJs],

      props.publishAt && [publishAtAtom, props.publishAt],
    ].filter(Boolean),
    {
      store,
    },
  );

  return <></>;
}
